import { Badge, Box, Flex, HStack, Link as ChakraLink, Tag, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useEffect, useState } from "react";

interface Props {
  data: any;
}

type Category = {
  title: string;
  color: string;
  bgColor: string;
  slug: string;
};

export default function CardPostHeader({ data }: Props) {
  const [category, setCategory] = useState<Category[]>([]);
  const [title, setTitle] = useState<string>("");
  const [postImage, setPostImage] = useState<string>("");
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    if (data.article) {
      setCategory(
        data.article.data.attributes?.category?.data.map((c: any) => c.attributes)
      );
      setTitle(data.article.data.attributes?.title);
      setPostImage(data.article.data.attributes?.mainImage?.data?.attributes.url);
      setUrl(`/blog/${data.article.data.attributes?.url}`);
    }
    if (data.breed) {
      setCategory(
        data.breed.data.attributes?.category?.data.map((c: any) => c.attributes)
      );
      setTitle(data.breed.data.attributes?.name);
      setPostImage(data.breed.data.attributes?.image?.data?.attributes.url);
      setUrl(`/raca/${data.breed.data.attributes?.url}`);
    }
  }, [data]);

  return (
    <>
      <Flex
        basis="0"
        grow="1"
        as={Link}
        href={url}
        height="100%"
        direction="column"
        justifyContent="flex-end"
        alignItems="flex-start"
        padding="0 !important"
        gap="24px"
        _hover={{ textDecoration: "none", boxShadow: "lg" }}
        borderRadius="8px"
        bg={`linear-gradient(180deg, rgba(45, 55, 72, 0) 0%, #2D3748 88.02%), center / cover no-repeat url(${postImage})`}
      >
        <Flex direction="column" alignItems="flex-start" gap="16px" padding="24px" height="100%" justifyContent="space-between">
        <HStack alignItems="center" gap="8px">
          {Boolean(category.length > 0) &&
            category.slice(0, 2).map((item: Category, index: number) => (
              <Badge 
                key={index}
                backgroundColor={item.bgColor}
                borderRadius='2px'
                px='4px'
                justifyContent='center'
                alignItems='center'
                gap='10px'
                color={item.color}
                textDecor='none'
                fontWeight={700}
                fontSize='12px'
                lineHeight='16px'
              >
                {item.title}
              </Badge>
            ))
          }
        </HStack>
          <Box>
            <Text
              color="white"
              fontWeight={700}
              fontSize="20px"
              lineHeight="24px"
            >
              {title}
            </Text>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
